import script from "./TextBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBlock.vue?vue&type=script&setup=true&lang=js"

import "./TextBlock.vue?vue&type=style&index=0&id=9206c4ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9206c4ae"]])

export default __exports__